"use client";

import { useContext } from "react";
import { BrandingContext } from "./BrandingProvider";
import type { ResolvedBranding } from "./types";

/**
 * Returns the resolved tenant branding. Throws if used outside a BrandingProvider
 * (a wiring bug — the provider is always mounted at the root layout).
 */
export function useBranding(): ResolvedBranding {
  const ctx = useContext(BrandingContext);
  if (ctx === null) {
    throw new Error("useBranding must be used within a BrandingProvider");
  }
  return ctx;
}
